var _ellipse, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecondaryLarge = function SvgSecondaryLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 241 241"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.277,
    cy: 120.405,
    fill: "#F07D00",
    rx: 120,
    ry: 120.405
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.518,
    cy: 109.518,
    r: 108.018,
    stroke: "#D5DBDE",
    strokeDasharray: "1 10",
    strokeWidth: 3,
    transform: "scale(.99831 1.00168)rotate(45 102.102 128.093)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.518,
    cy: 109.518,
    r: 105.518,
    stroke: "#D5DBDE",
    strokeDasharray: "1 60",
    strokeWidth: 8,
    transform: "scale(.99831 1.00168)rotate(45 102.102 128.093)"
  })));
};
export default SvgSecondaryLarge;